module.exports = __webpack_public_path__ + "static/media/marilyn-logo.28515347.png";